import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var CodeInserter = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M25.534 5.741a1 1 0 0 1 1.932.518l-8.784 32.785a1 1 0 1 1-1.932-.518l8.784-32.785ZM.357 23.605a1.908 1.908 0 0 1 .003-2.228l.014-.02L9.552 9.877a1 1 0 0 1 1.563 1.249L2.027 22.493l9.088 11.384a1 1 0 1 1-1.563 1.247L.372 23.625l-.015-.02ZM43.643 23.605a1.908 1.908 0 0 0-.003-2.228l-.014-.02-9.178-11.481a1 1 0 0 0-1.562 1.249l9.087 11.368-9.088 11.384a1 1 0 0 0 1.563 1.247l9.18-11.499.015-.02Z"
  }));
});
CodeInserter.displayName = 'CodeInserter';
CodeInserter.defaultProps = {
  'aria-label': 'CodeInserter'
};
export default CodeInserter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/CodeInserter.js
// module id = 3536
// module chunks = 11